module.exports = __webpack_public_path__ + "static/people_and_change_conuslting-e660fcc08f712d1a3135d25d221c2ade.jpg";